import React from 'react';

import CommonNode from '../../../components/node/common-node';
import { NodeProvider } from '../../../context/node-context';
import CanvasWriterForm from '../forms/canvas-writer-form';
import { canvasWriterValidationSchema } from '../schema/canvasWriter.js';

export default function CanvasWriterNode({ data, id, type }) {
  return (
    <NodeProvider
      nodeData={data}
      id={id}
      type={type}
      metaData={{
        modalTitle: data?.label || 'Canvas Writer Node Details',
        altText: 'Canvas Writer Node',
        defaultLabel: 'Canvas Writer Node',
      }}
    >
      <CommonNode FormComponent={CanvasWriterForm} schemaResolver={canvasWriterValidationSchema} />
    </NodeProvider>
  );
}
